import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UserModel extends BaseModel {

    constructor() {
        super({
                name: "user",
                tableName: 'users',
                label: "Quản Lý Người dùng",
                /* display_key: 'fullname',
                 default_order: { key: 'updated_at', direction: 'asc' }*/
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    class: "center",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                fullname: { 
                    name: 'fullname',
                    type: "String",
                    label: 'Tên khách hàng',
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                },
                email : { 
                    name: 'email',
                    type: "String",
                    label: 'Email',
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                },
                phone: { 
                    name: 'phone',
                    type: "String",
                    class: "center",
                    label: 'Số điện thoại',
                    sortable: false,
                    filter: {type: 'input', match: 'contains'},
                },
                company_id: {
                    name: 'company_id',
                    type: "Uuid",
                    label: 'ID công ty',
                    display: false
                },
                farm_id: {
                    name: 'farm_id',
                    type: "Uuid",
                    label: 'ID trang trại',
                    display: false
                },
                company_name: {
                    name: 'company_name',
                    type: "String",
                    class: "center",
                    label: 'Tên công ty',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                farm_name: {
                    name: 'farm_name',
                    type: "String",
                    class: "center",
                    label: 'Tên trang trại',
                    sortable: false,
                    filter: {
                        type: 'input',
                        match: 'contains'
                    },
                },
                id: {
                    name: 'id',
                    type: "Uuid",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                status: { 
                    name: 'status',
                    label: 'status',
                    type: "Int",
                    display: false,
                },
                updated_at : { 
                    name: 'updated_at', 
                    type: "CustomDate", 
                    label: 'Ngày cập nhật',
                    display: false, 
                    sortable: true,  
                    filter: false,
                },
                username: {
                name: "username",
                label: "Tên đăng nhập",
                type: "String",
                filter: { type: "input", match: "contains" },
                display: false,
                },
                role: {
                    name: 'name',
                    type: 'String',
                    class: 'center',
                    label: 'Vai trò',
                    sortable: false,
                    filter: { type: 'input', match: 'contains' }
                },
                active: {
                    name: "active",
                    type: "Selection", 
                    custom: 'SelectionText',
                    label: "Trạng thái",
                    class: "center",
                    options: [
                        {value : true , label: "Hoạt động"},
                        {value : false , label : "Không hoạt động"}
                    ],
                    filter: { type: 'select', optionLabel: 'label', optionKey: 'value', match: 'equals' }
                },
                created_by: {
                    name: 'created_by',
                    type: "String",
                    class: "center",
                    label: 'Người tạo',
                    sortable: false,
                    filter: {type: 'input', match: 'contains'},
                    computed: (data) => {
                        data.created_by = "";
                    }
                },
                created_at: {
                    name: 'created_at',
                    type: "Datetime",
                    class: "center",
                    label: 'Ngày tạo',
                    filter: {
                        type: "DateRange", match: "contrains",
                    },
                },
                
                users_role: {
                    refs: 'users_role {id role name}',
                    display: false
                },

                created_by_user: {
                    refs: 'created_by_user {id fullname}',
                    display: false
                },
            },
            )
    }

}